// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "*{margin:0;-webkit-font-smoothing:antialiased;font-family:PingFang SC,Microsoft YaHei,Hiragino Sans GB,WenQuanYi Micro Hei,Arial,sans-serif,Apple Color Emoji,Segoe UI Emoji}", ""]);
// Exports
module.exports = exports;
